module.exports = __webpack_public_path__ + "static/media/actiLogo.3a42a900.jpg";